module.exports = __webpack_public_path__ + "static/media/8Chatbot.64ed000c.png";